import React, { useEffect, useMemo, useState } from "react";
import ConsentTemplate from "./ConsentTemplate";

export const SelectedSurveysRunner = ({
    selectedSurveys = [],
    onFinish,
    onClose,
    isSampling = false
}) => {
    // console.log("🚀 ~ SelectedSurveysRunner ~ onClose:", onClose)
    // console.log("🚀 ~ SelectedSurveysRunner ~ onFinish:", onFinish)
    // console.log("🚀 ~ SelectedSurveysRunner ~ selectedSurveys:", selectedSurveys)

    const [currentSurveyIndex, setCurrentSurveyIndex] = useState(0);
    const [surveyResults, setSurveyResults] = useState([]);


    const surveys = useMemo(() => {
        return selectedSurveys
            .map((selectedItem) => selectedItem?.survey)
            .filter(Boolean);
    }, [selectedSurveys]);

    const currentSurvey = surveys[currentSurveyIndex];

    useEffect(() => {
        setCurrentSurveyIndex(0);
        setSurveyResults([]);
    }, [selectedSurveys]);


    console.log("🚀 ~ SelectedSurveysRunner ~ surveys:", surveys)


    const handleSurveyFinish = (result) => {

        if (!currentSurvey) {
            return;
        }

        const currentResult = {
            id_template: currentSurvey.id_template,
            title: currentSurvey.title,
            version: currentSurvey.version,
            result
        };

        const updatedResults = [
            ...surveyResults,
            currentResult
        ];

        setSurveyResults(updatedResults);

        const isLastSurvey =
            currentSurveyIndex ===
            surveys.length - 1;

        if (isLastSurvey) {

            if (typeof onFinish === "function") {
                onFinish({
                    selectedSurveyIds:
                        surveys.map(
                            survey =>
                                survey.id_template
                        ),
                    surveys: updatedResults
                });
            }

            return;
        }

        setCurrentSurveyIndex(
            previousIndex =>
                previousIndex + 1
        );
    };

    if (surveys.length === 0) {
        return (
            <div className="sampling-question-runner-empty">
                <i className="fa fa-file-text-o"></i>

                <h5>
                    No se a seleccionado ninguna encuestas
                </h5>

                <p>
                    Selecciona al menos una encuesta para continuar.
                </p>
            </div>
        );
    }

    return (
        <div className="sampling-question-runner">
            <ConsentTemplate
                key={currentSurvey?.id_template}
                template={currentSurvey}
                onFinish={handleSurveyFinish}
                isSampling={isSampling}
            />
            {onClose && (
                <div className="sampling-question-runner-close-container">
                    <button
                        type="button"
                        className="sampling-question-runner-close-button"
                        onClick={onClose}
                    >
                        <i className="fa fa-times"></i>
                        Cerrar encuestas
                    </button>
                </div>
            )}
        </div>
    );
};